"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamsError = exports.receiveTeams = exports.receiveTeamsStarted = exports.TEAMS_ERROR = exports.RECEIVE_TEAMS = exports.RECEIVE_TEAMS_STARTED = void 0;
exports.default = reducer;
exports.loadTeams = loadTeams;
const api_1 = require("core/api");
const lodash_1 = require("lodash");
// Actions
exports.RECEIVE_TEAMS_STARTED = 'RECEIVE_TEAMS_STARTED';
exports.RECEIVE_TEAMS = 'RECEIVE_TEAMS';
exports.TEAMS_ERROR = 'TEAMS_ERROR';
// Reducer
const initialState = { teams: [], teamsLoaded: false };
function reducer(state = initialState, action = {}) {
    const teams = action.data;
    switch (action.type) {
        case 'RECEIVE_TEAMS_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_TEAMS':
            return {
                ...state,
                teamsLoaded: true,
                teams: teams,
                activeTeams: (0, lodash_1.filter)(teams, (t) => !t.isRetired && !t.isArchivedSeason),
                retiredTeams: (0, lodash_1.filter)(teams, (t) => t.isRetired),
                recentTeam: (0, lodash_1.reduce)(teams, (tr, tc) => {
                    return new Date(tr.updatedAt) > new Date(tc.updatedAt) ? tr : tc;
                }),
            };
        case 'TEAMS_ERROR':
            return {
                ...state,
                teamsLoaded: false,
                error: action.data,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveTeamsStarted = () => {
    return {
        type: exports.RECEIVE_TEAMS_STARTED,
    };
};
exports.receiveTeamsStarted = receiveTeamsStarted;
const receiveTeams = (data) => {
    return {
        type: exports.RECEIVE_TEAMS,
        data,
    };
};
exports.receiveTeams = receiveTeams;
const teamsError = (data) => {
    return {
        type: exports.TEAMS_ERROR,
        data,
    };
};
exports.teamsError = teamsError;
// services
function loadTeams(memberTeamIds) {
    return (dispatch) => {
        dispatch((0, exports.receiveTeamsStarted)());
        return api_1.TeamService.getTeams(memberTeamIds)
            .then((res) => {
            dispatch((0, exports.receiveTeams)(res));
        })
            .catch((error) => {
            dispatch((0, exports.teamsError)(error));
        });
    };
}
